import { createApp } from 'vue'
import DebtRepayment from './DebtRepayment.vue'
import './assets/global.css'

createApp(DebtRepayment).mount('#debt-repayment')
